<template>
    <v-overlay v-model="active"
               :style="{ 'backdrop-filter': active ? 'blur(2px)' : '' }"
               color="rgba(255,0,0,1)"
    >
        <v-row justify="center" align="center" class="mb-5">
            <v-icon size="88">mdi-close-circle-outline</v-icon>
        </v-row>
        <v-row justify="center" align="center" class="mb-5">
            <v-col cols="12">
                <v-row justify="center">
                    <div class="display-1 font-weight-light">
                        {{$t(title || 'errors.general.title')}}
                    </div>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-row justify="center">
                    <div class="text-center">
                        {{$t(message || 'errors.general.description')}}
                    </div>
                </v-row>
            </v-col>
        </v-row>
        <v-row justify="center" align="center" v-if="afterText">
            <v-btn text
                   @click="after ? after() : setErrorState()"
                   large
                   style="background-color: rgba(255,0,0,0.3)"
            >
                {{$t(afterText)}}
            </v-btn>
        </v-row>
    </v-overlay>
</template>

<script>
    export default {
        name: "SystemErrorOverlay",
        props: {
            active: {
                type: Boolean,
                default: false
            },
          title: {type: String},
          message: {type: String},
          afterText: {type: String},
          after: {type: Function}
        },
        computed: {

        },
        methods: {
            setErrorState() {
                this.$emit('dismiss');
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>